import { React, useState, useEffect, useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Dialog } from "primereact/dialog";
import { useForm, Controller } from "react-hook-form";
import { RadioButton } from "primereact/radiobutton";
import InputTextElement from "../../../../Components/UiComponents/InputTextElement";
import "../../../../../src/App.css";
import _ from "lodash";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
// UI components
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import DropdownElement from "../../../../Components/UiComponents/DropdownElement";
import Loader from "../../../../Components/UiComponents/Loader";
// Services
import { updateUser, userCheck } from "../../../../Services/userService";
import config from "../../../../Utils/Constants.json";
import { checkCustomerEmail } from "../../../../Services/customerServices";

export default function EditUsers(props) {
  const [visible, setVisible] = useState(false);
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
    watch,
  } = useForm();

  var enduser = localStorage.getItem("user_privileges")
  if (enduser) {
    var tmpPrivilege = JSON.parse(enduser);
    if (tmpPrivilege !== undefined && tmpPrivilege !== null) {
      var userPrivilege = tmpPrivilege[0].user_readwrite;
    }
  }
  const toastRef = useRef();

  useEffect(() => {
    reset();
    // To auto populate form
    if (props?.editUser && props?.customerOptions) {
      const edit = _.cloneDeep(props.editUser);
      edit.firstname = props?.editUser?.firstname;
      edit.surname = props?.editUser?.surname;
      edit.username = props?.editUser?.username;
      edit.phone_number = props?.editUser?.phone_number;
      edit.mobile_number = props?.editUser?.mobile_number;
      edit.email = props?.editUser?.email;
      edit.hourlyrate = props?.editUser?.hourlyrate;
      edit.branch = props?.editUser?.branch?.branch_id;
      edit.status = props?.editUser?.status;
      edit.role_name = props?.editUser?.responsibility;
      edit.business_unit = props?.editUser?.business_unit;
      edit.isRestricted = props?.editUser?.isRestricted;
      edit.isAdmin = props?.editUser?.isAdmin;
      setEditData(edit);
    }
  }, [props.customerId, props?.visibleEdit, props.editUser]);

  useEffect(() => {
    // Sync restricted and admin states with props changes
    if (getValues("isRestricted")) {
      setValue("isAdmin", false);
    }
  }, [watch("isRestricted")]);

  const Status = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    { value: "left the company", label: "Left the company" },
  ];

  // Function to update checklist
  const onSubmit = async (promptData) => {
    var newPromptData = props?.editUser;
    newPromptData.customer_id = props?.customerId;
    newPromptData.business_unit = promptData?.business_unit?.label;
    newPromptData.status = promptData?.status;
    newPromptData.role_name = promptData?.responsibility.role_name;
    newPromptData.branch = {
      branch_id: promptData?.branch?.id || props.branch.branch_id,
      branch_key: promptData?.branch?.branch_key || props.branch.branch_key,
    };
    newPromptData.firstname = promptData?.firstname;
    newPromptData.surname = promptData?.surname;
    newPromptData.username = promptData?.username;
    newPromptData.phone_number = promptData?.phone_number;
    newPromptData.mobile_number = promptData?.mobile_number;
    newPromptData.hourlyrate = promptData?.hourlyrate;
    newPromptData.isAdmin = promptData?.isAdmin;
    newPromptData.isRestricted = promptData?.isRestricted;
    newPromptData.email = promptData?.email;
    newPromptData.isBranchAdmin = promptData?.isBranchAdmin

    try {
      setLoading(true);
      if (userPrivilege == config[0].readOnly) {
        toastRef.current.showToast({
          type: "error",
          message: "You do not have permission to update",
        });
      } else if (userPrivilege == config[1].readWrite) {
        var checkEmail = await checkCustomerEmail(newPromptData, newPromptData.customer_id)
        if (checkEmail && checkEmail.data) {
          if (checkEmail.data.count >= 1) {
            toastRef.current.showToast({
              type: "error",
              message: props.customerControlFields && props.customerControlFields.tabs[1]?.display_name + "Email Id already Exists",
            });
          }
          else {
            const response = await updateUser(
              editData._id,
              newPromptData.customer_id,
              newPromptData.branch,
              newPromptData
            );
            if (response && response?.status === 200) {
              closePopup();
              toastRef.current.showToast({
                type: "success",
                message: `${props.customerControlFields &&
                  props.customerControlFields.tabs[1]?.display_name
                  } Info Updated Successfully`,
              });
            } else {
              toastRef.current.showToast({
                type: "error",
                message: "Error",
              });
            }
          }
        }
      }
    } catch (e) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false);
    }
  };

  const closePopup = () => {
    reset();
    setVisible(false);
    props.onHide();
  };

  const resetpassword = async () => {
    try {
      var userData = { username: getValues("username"), emailId: getValues("email") }
      var userReset = await userCheck(userData)
      if (userReset && userReset.data) {
        toastRef.current.showToast({
          type: "success",
          message: "Mail sent to User",
        });
      }
    } catch (e) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  }

  const renderFooter = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement type="button" label="Resend Password Link" className="cancel-new-button" onClick={resetpassword} />
          <ButtonElement
            type="submit"
            label="Update"
            className="save-button"
            onClick={handleSubmit(onSubmit)}
          />
        </div>
      </div>
    );
  };

  return (
    <div>
      <ToastElement ref={toastRef} />
      <Loader loading={loading} />
      <Dialog
        header={`Edit ${props.customerControlFields &&
          props.customerControlFields.tabs[1]?.display_name
          } Info`}
        visible={props.visible}
        position={props.position}
        className="width-42vw"
        onHide={() => {
          closePopup();
        }}
        footer={renderFooter()}
        draggable={false}
      >
        <div className="new-field">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[1].tables[0].headers[0]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="firstname"
                  control={control}
                  defaultValue={props?.editUser?.firstname}
                  rules={{ required: "First Name must be between 2-500 characters" }}
                  render={({ field }) => (
                    <InputTextElement
                      id="firstname"
                      placeholder="First name"
                      value={props?.editUser?.firstname}
                      {...field}
                    />
                  )}
                />
                {errors?.firstname && (
                  <small className="text-red-500 ml-1 color_red_new">
                    {errors?.firstname.message}
                  </small>
                )}
              </div>
            </div>

            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[1].tables[0].headers[1]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="surname"
                  control={control}
                  defaultValue={editData?.surname}
                  rules={{ required: "Surname must be between 2-500 characters" }}
                  render={({ field }) => (
                    <InputTextElement
                      id="surname"
                      placeholder="Surname"
                      value={props?.editUser?.surname}
                      {...field}
                    />
                  )}
                />
                {errors?.surname && (
                  <small className="text-red-500 ml-1 color_red_new">
                    {errors?.surname.message}
                  </small>
                )}
              </div>
            </div>

            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[1].tables[0].headers[7]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="phone_number"
                  control={control}
                  defaultValue={editData?.phone_number}
                  // rules={{ required: "First Name is required" }}
                  render={({ field }) => (
                    <InputTextElement
                      id="phone_number"
                      placeholder="Phone number"
                      value={props?.editUser?.phone_number}
                      {...field}
                    />
                  )}
                />
              </div>
            </div>

            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[1].tables[0].headers[8]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="mobile_number"
                  control={control}
                  defaultValue={editData?.mobile_number}
                  render={({ field }) => (
                    <InputTextElement
                      id="mobile_number"
                      placeholder="Mobile number"
                      value={props?.editUser?.mobile_number}
                      {...field}
                    />
                  )}
                />
              </div>
            </div>

            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[1].tables[0].headers[4]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="email"
                  control={control}
                  defaultValue={editData?.email}
                  rules={{
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid email format",
                    },
                  }}
                  render={({ field }) => (
                    <InputTextElement
                      id="email"
                      placeholder="Email"
                      value={props?.editUser?.email}
                      {...field}
                    />
                  )}
                />
                {errors?.email && (
                  <small className="text-red-500 ml-1 color_red_new">
                    {errors?.email.message}
                  </small>
                )}
              </div>
            </div>

            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[1].tables[0].headers[2]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="username"
                  control={control}
                  defaultValue={editData?.username}
                  rules={{ required: "Username must be between 2-500 characters" }}
                  render={({ field }) => (
                    <InputTextElement
                      id="username"
                      placeholder="Username"
                      value={props?.editUser?.username}
                      {...field}
                    />
                  )}
                />
                {errors?.username && (
                  <small className="text-red-500 ml-1 color_red_new">
                    {errors?.username.message}
                  </small>
                )}
              </div>
            </div>

            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[1].tables[0].headers[9]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="hourlyrate"
                  control={control}
                  defaultValue={editData?.hourlyrate}
                  rules={{
                    required: "Hourly rate is required",
                    pattern: {
                      value: /^\d+(\.\d{1,2})?$/,
                      message: "Hourly rate must be a number with up to two decimal places"
                    }
                  }}
                  render={({ field }) => (
                    <InputTextElement
                      id="hourlyrate"
                      placeholder="Hourly Rate"
                      // value={props?.editUser?.hourlyrate}
                      {...field}
                    />
                  )}
                />
                {errors?.hourlyrate && (
                  <small className="text-red-500 ml-1 color_red_new">
                    {errors?.hourlyrate.message}
                  </small>
                )}
              </div>
            </div>
            {
              props.havingBranch && !props.branchAdmin &&
              <div className="form-group row align-items-center mb-0">
                <div className="col-md-4 pl-0">
                  <label className="form-label text-left">Branch</label>
                </div>
                <div className="col pr-0">
                  <Controller
                    name="branch"
                    control={control}
                    defaultValue={
                      props?.customerOptions?.Branches?.filter(
                        (item) => item.id === props?.editUser?.branch?.branch_id
                      )[0]
                    }
                    style={{ innerHeight: 10 }}
                    rules={{ required: "Branch is required" }}
                    render={({ field }) => (
                      <DropdownElement
                        onChange={(e) => field.onChange(e.branch)}
                        id="branch"
                        options={(props?.customerOptions?.Branches != undefined && props?.customerOptions?.Branches.length > 0) ? props?.customerOptions?.Branches : []}
                        optionLabel="label"
                        placeholder="-- Please select --"
                        className="w-full"
                        {...field}
                        maxSelectedLabels={1}
                      />
                    )}
                  />
                  {errors.branch && (
                    <small className="text-red-500 ml-1 color_red_new">
                      {errors.branch.message}
                    </small>
                  )}
                </div>
              </div>
            }
            <div className="form-group row align-items-center mb-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[1].tables[0].headers[10]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="responsibility"
                  control={control}
                  defaultValue={
                    props.customerOptions.Roles?.filter(
                      (item) => item.role_name === props?.editUser?.role_name
                    )[0]
                  }
                  style={{ innerHeight: 10 }}
                  rules={{ required: "Responsibility is required" }}
                  render={({ field }) => (
                    <DropdownElement
                      onChange={(e) => field.onChange(e.role_name)}
                      id="responsibility"
                      options={(props.customerOptions.Roles != undefined && props.customerOptions.Roles.length > 0) ? props.customerOptions.Roles : []}
                      optionLabel="role_name"
                      placeholder="-- Please select --"
                      className="w-full"
                      {...field}
                      maxSelectedLabels={1}
                    // value={props?.customerOptions?.Roles?.find((role)=>role?.role_name === editData.role_name)}
                    />
                  )}
                />
                {errors.responsibility && (
                  <small className="text-red-500 ml-1 color_red_new">
                    {errors.responsibility.message}
                  </small>
                )}
              </div>
            </div>

            <div className="form-group row align-items-center mb-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[1].tables[0].headers[11]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="business_unit"
                  control={control}
                  defaultValue={
                    props.customerOptions.BusinessUnitOpts?.filter(
                      (item) => item.label === props?.editUser?.business_unit
                    )[0]
                  }
                  style={{ innerHeight: 10 }}
                  // rules={{ required: "Business Unit is required" }}
                  render={({ field }) => (
                    <DropdownElement
                      onChange={(e) => field.onChange(e.label)}
                      id="business_unit"
                      options={(props.customerOptions.BusinessUnitOpts != undefined && props.customerOptions.BusinessUnitOpts.length > 0) ? props.customerOptions.BusinessUnitOpts : []}
                      optionLabel="label"
                      placeholder="-- Please select --"
                      className="w-full"
                      {...field}
                      maxSelectedLabels={1}
                    />
                  )}
                />
                {/* {errors.business_unit && (
                  <small className="text-red-500 ml-1 color_red_new">
                    {errors.business_unit.message}
                  </small>
                )} */}
              </div>
            </div>

            <div className="form-group row align-items-center mb-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[1].tables[0].headers[5]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="status"
                  control={control}
                  // defaultValue={Status?.filter(
                  //   (item) => item.value === props?.editUser?.status
                  // )}
                  defaultValue={props?.editUser?.status}
                  // rules={{ required: "Status is required" }}
                  style={{ innerHeight: 10 }}
                  render={({ field }) => (
                    <DropdownElement
                      onChange={(e) => field.onChange(e.value)}
                      id="status"
                      options={(Status != undefined && Status.length > 0) ? Status : []}
                      optionLabel="label"
                      placeholder="-- Please select --"
                      className="w-full"
                      {...field}
                      maxSelectedLabels={1}
                    />
                  )}
                />

                {/* {errors.status && (
                  <small className="text-red-500 ml-1 color_red_new">
                    {errors.status.message}
                  </small>
                )} */}
              </div>
            </div>

            <div className="form-group row align-items-center mt-0 mb-0">
              <div className="col-md-4 text-left pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[1].tables[0].headers[12]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="isRestricted"
                  control={control}
                  defaultValue={props?.editUser?.isRestricted}
                  render={({ field }) => (
                    <>
                      <RadioButton
                        inputId="restricted-yes"
                        value={true}
                        onChange={(e) => {
                          field.onChange(e.value);
                        }}
                        checked={field.value === true}
                      />
                      <label
                        htmlFor="restricted-yes"
                        className="p-radiobutton-label"
                      >
                        Yes
                      </label>
                      <RadioButton
                        inputId="restricted-no"
                        value={false}
                        onChange={(e) => {
                          field.onChange(e.value);
                        }}
                        checked={field.value === false}
                        className="ml-20"
                      />
                      <label
                        htmlFor="restricted-no"
                        className="p-radiobutton-label"
                      >
                        No
                      </label>
                    </>
                  )}
                />
              </div>
            </div>
            {
              !props.adminVisible &&
              <div className="form-group row align-items-center mt-0 mb-0">
                <div className="col-md-4 text-left pl-0">
                  <label className="form-label text-left">
                    {props.customerControlFields &&
                      props.customerControlFields.tabs[1].tables[0].headers[13]
                        ?.display_name}
                  </label>
                </div>
                <div className="col pr-0">
                  <Controller
                    name="isBranchAdmin"
                    control={control}
                    defaultValue={props?.editUser?.isBranchAdmin}
                    render={({ field }) => (
                      <>
                        <RadioButton
                          inputId="branchAdmin-yes"
                          value={true}
                          disabled={getValues("isRestricted")}
                          onChange={(e) => {
                            field.onChange(e.value);

                          }}
                          checked={field.value === true}
                        />
                        <label
                          htmlFor="branchAdmin-yes"
                          className="p-radiobutton-label"
                        >
                          Yes
                        </label>
                        <RadioButton
                          inputId="branchAdmin-no"
                          value={false}
                          onChange={(e) => {
                            field.onChange(e.value);

                          }}
                          checked={field.value === false}
                          className="ml-20"
                        />
                        <label htmlFor="branchAdmin-no" className="p-radiobutton-label">
                          No
                        </label>
                      </>
                    )}
                  />
                </div>
              </div>
            }
            {
              props.adminVisible &&
              <div className="form-group row align-items-center mt-0 mb-0">
                <div className="col-md-4 text-left pl-0">
                  <label className="form-label text-left">
                    {props.customerControlFields &&
                      props.customerControlFields.tabs[1].tables[0].headers[13]
                        ?.display_name}
                  </label>
                </div>
                <div className="col pr-0">
                  <Controller
                    name="isAdmin"
                    control={control}
                    defaultValue={props?.editUser?.isAdmin}
                    render={({ field }) => (
                      <>
                        <RadioButton
                          inputId="admin-yes"
                          value={true}
                          disabled={getValues("isRestricted")}
                          onChange={(e) => {
                            field.onChange(e.value);

                          }}
                          checked={field.value === true}
                        />
                        <label
                          htmlFor="admin-yes"
                          className="p-radiobutton-label"
                        >
                          Yes
                        </label>
                        <RadioButton
                          inputId="admin-no"
                          value={false}
                          onChange={(e) => {
                            field.onChange(e.value);

                          }}
                          checked={field.value === false}
                          className="ml-20"
                        />
                        <label htmlFor="admin-no" className="p-radiobutton-label">
                          No
                        </label>
                      </>
                    )}
                  />
                </div>
              </div>
            }
          </form>
        </div>
      </Dialog>
    </div>
  );
}
